import { DecryptModalComponent } from './decrypt-modal/decrypt-modal.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DeploymentComponent } from './deployment.component';
import { DeploymentService } from './core/services/deployment.service';
import { SharedModule, HttpLoaderFactory } from '../shared/shared.module';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { DeploymentConfirmAlertComponent } from './deployment-confirm.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { UploadBexComponent } from './upload-bex/upload-bex.component';
import { PreviousProcessesTableComponent } from './previous-processes-table/previous-processes-table.component';
import { PackageVisualizerComponent } from './package-visualizer/package-visualizer.component';
import { StoreModule } from '@ngrx/store';
import { DEPLOYMENT_BEX_REDUCER } from './store/reducers/deployment-feature.reduer';
import { PackageVisualizerTopbarComponent } from './package-visualizer-topbar/package-visualizer-topbar.component';
import { PackageVisualizerBreadcrumbComponent } from './package-visualizer-breadcrumb/package-visualizer-breadcrumb.component';
import { PackageVisualizerListComponent } from './package-visualizer-list/package-visualizer-list.component';
import { PackageVisualizerFiltersComponent } from './package-visualizer-filters/package-visualizer-filters.component';
import { DeploymentPackageMaintenanceWindowComponent } from './package-maintenance-window/package-maintenance-window.component';
import { PackageImportModalComponent } from './package-import-modal/package-import-modal.component';
import {PackageDependenciesComponent} from './package-dependencies/package-dependencies.component';
import {PackageDependenciesService} from './package-dependencies/package-dependencies.service';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { PackageSearchContainerComponent } from './package-search-container/package-search-container.component';
import { WorkspaceMigrationModalComponent } from './workspace-migration-modal/workspace-migration-modal.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    HttpClientModule,
    NgxGraphModule,
    NgxChartsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    StoreModule.forFeature('deployment', DEPLOYMENT_BEX_REDUCER)
  ],
  declarations: [
    DeploymentComponent,
    DeploymentConfirmAlertComponent,
    DecryptModalComponent,
    UploadBexComponent,
    PreviousProcessesTableComponent,
    PackageVisualizerComponent,
    PackageVisualizerTopbarComponent,
    PackageVisualizerBreadcrumbComponent,
    PackageVisualizerListComponent,
    PackageVisualizerFiltersComponent,
    DeploymentPackageMaintenanceWindowComponent,
    PackageImportModalComponent,
    PackageDependenciesComponent,
    PackageSearchContainerComponent,
    WorkspaceMigrationModalComponent
  ],
  providers: [DeploymentService, DatePipe, PackageDependenciesService],
  exports: [DeploymentComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DeploymentModule {}
